import aquarium from './Aquarium.png';
import balloon from './Balloon.png';
import bonusGirl from './BonusGirl.png';
import finishZero from './FinishZero.png';
import gorilla from './Gorilla.png';
import heartGirl from './HeartGirl.png';
import moneymanGirl from './MoneymanGirl.png';
import rockStars from './RockStars.png';
import tourists from './Tourists.png';

export const images = {
    aquarium,
    bonusGirl,
    finishZero,
    gorilla,
    heartGirl,
    moneymanGirl,
    balloon,
    rockStars,
    tourists,
} as const;
